import { capacitorService } from '../../../application/CapacitorService';
import { revenueCatService } from '../../../application/RevenueCatService';
import { useRetrieveDriverCredentials } from './useRetrieveDriverCredentials';
import { useRetrieveVehicle } from './useRetrieveVehicle';

export const usePermissions = () => {
  const { data: vehicleData } = useRetrieveVehicle();
  const { data: credentials } = useRetrieveDriverCredentials();

  const isSoloDriver = credentials?.subscription.isSoloDriversPlan();

  const hasSubscription = credentials?.subscription.isDriversLitePlan();

  const canManageStops = Boolean(credentials?.test(`can_manage_stops`));

  const canManageRoutes = Boolean(credentials?.test(`can_manage_routes`));

  const canSubscribe = isSoloDriver && !hasSubscription && revenueCatService.isLogged() && !capacitorService.isWeb();

  const canCreateRoutes = isSoloDriver && canManageRoutes;

  const canReorderStops = Boolean(credentials?.test(`can_update_route_order`));

  const canOpenHelp = capacitorService.isNative();

  const canEditEmail = isSoloDriver && !vehicleData?.vehicle.email;

  const canReferUsers = isSoloDriver;

  const canCreateSurvey = Boolean(credentials?.test(`can_create_survey`));

  return {
    isSoloDriver,
    hasSubscription,
    canReferUsers,
    canSubscribe,
    canCreateRoutes,
    canOpenHelp,
    canEditEmail,
    canManageStops,
    canManageRoutes,
    canReorderStops,
    canCreateSurvey,
  };
};
